import { apiErrorMessage, unwrapApiData } from '../auth/saasSession';

export const incidentMutationResult = (
  axiosResponse,
  fallback = 'The incident change could not be completed.',
) => {
  const envelope = axiosResponse?.data;
  const data = unwrapApiData(envelope);
  return {
    data,
    error: data == null ? apiErrorMessage(envelope, fallback) : '',
  };
};
